/* TerraLife — actions de la page Favoris (snippets/terralife-wishlist-tools.liquid).
   Les favoris sont les identifiants produit de localStorage « glozin__wishlist-items » ;
   une liste partagée arrive par ?ids=… (assets/wishlist.js l'affiche à la place). */
(() => {
  const KEY = 'glozin__wishlist-items';
  const bar = document.querySelector('[data-tl-wl-tools]');
  if (!bar) return;
  const msg = bar.querySelector('[data-tl-wl-msg]');
  const shared = (new URLSearchParams(location.search).get('ids') || '').split(',').filter((x) => /^\d+$/.test(x));
  const own = () => {
    try {
      return (JSON.parse(localStorage.getItem(KEY)) || []).map(String);
    } catch (e) {
      return [];
    }
  };
  const say = (text) => (msg.textContent = text);
  const handles = () =>
    [...document.querySelectorAll('.wishlist-page-main .wl-product-js[data-product-handle]')].map((el) => el.dataset.productHandle);

  // Shown once the list has products (it is loaded after the page).
  const sync = () => {
    bar.hidden = handles().length === 0;
  };
  const main = document.querySelector('.wishlist-page-main');
  if (main) new MutationObserver(sync).observe(main, { childList: true, subtree: true });
  sync();

  if (shared.length) {
    bar.querySelector('[data-tl-wl-shared]').hidden = false;
    bar.querySelector('[data-tl-wl-share]').hidden = true;
    bar.querySelector('[data-tl-wl-keep]').hidden = false;
  }

  bar.querySelector('[data-tl-wl-cart]').addEventListener('click', async (event) => {
    const button = event.currentTarget;
    button.disabled = true;
    say('Ajout en cours…');
    const items = [];
    let unavailable = 0;
    for (const handle of handles()) {
      try {
        const product = await (await fetch(`/products/${encodeURIComponent(handle)}.js`)).json();
        const variant = product.variants.find((v) => v.available);
        if (variant) items.push({ id: variant.id, quantity: 1 });
        else unavailable += 1;
      } catch (e) {
        unavailable += 1;
      }
    }
    if (!items.length) {
      button.disabled = false;
      say('Aucun de ces produits n\'est disponible pour le moment : utilise « M\'avertir » sur leur carte.');
      return;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      button.disabled = false;
      say('L\'ajout au panier n\'a pas fonctionné, réessaie depuis les cartes produits.');
      return;
    }
    say(
      `${items.length} produit${items.length > 1 ? 's' : ''} ajouté${items.length > 1 ? 's' : ''} au panier` +
        (unavailable ? ` (${unavailable} épuisé${unavailable > 1 ? 's' : ''} non ajouté${unavailable > 1 ? 's' : ''}).` : '.') +
        ' Redirection vers le panier…'
    );
    setTimeout(() => (location.href = '/cart'), 1200);
  });

  bar.querySelector('[data-tl-wl-share]').addEventListener('click', async () => {
    const ids = own();
    if (!ids.length) return;
    const url = `${location.origin}/pages/wishlist?ids=${ids.slice(0, 50).join(',')}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Ma liste TerraLife', url });
        return;
      }
      await navigator.clipboard.writeText(url);
      say('Lien de ta liste copié : tu peux le coller où tu veux.');
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      say(`Voici le lien de ta liste : ${url}`);
    }
  });

  bar.querySelector('[data-tl-wl-keep]').addEventListener('click', () => {
    const merged = [...new Set([...own(), ...shared])];
    localStorage.setItem(KEY, JSON.stringify(merged));
    document.querySelectorAll('.wishlist-count').forEach((el) => (el.textContent = merged.length));
    say('Ajouté à tes favoris.');
  });
})();
